export type DiscoverState = {
    activeBrands: [];
    activeFilters: [];
    attributeFilters: [];
    categoryPath: {
        id: number;
        href: string;
        isTopLevel: boolean;
        selected: boolean;
        name: string;
    }[];
    currentCategoryId: number;
    endpoint: null;
    error: null;
    filterCategories: unknown;
    filterPrice: unknown;
    filters: unknown;
    hasResult: boolean;
    headerText: string | null;
    internalSearch: unknown;
    introText: string | null;
    isFetchingGeolocation: boolean;
    isFilterOpen: boolean;
    isSavedSearchEmailEnabled: boolean;
    isShopOwnedByCurrentMember: boolean;
    items: [];
    itemsOnDisplay: [];
    mainText: string | null;
    pagination: unknown;
    queryParams: unknown;
    totalItems: number;
    reduxContainer: unknown;
    searchLanguages: [];
};

export const initialState: DiscoverState = {
    activeBrands: [],
    activeFilters: [],
    attributeFilters: [],
    categoryPath: [],
    currentCategoryId: 0,
    endpoint: null,
    error: null,
    filterCategories: {},
    filterPrice: {},
    filters: {},
    hasResult: false,
    headerText: null,
    internalSearch: {},
    introText: null,
    isFetchingGeolocation: false,
    isFilterOpen: false,
    isSavedSearchEmailEnabled: false,
    isShopOwnedByCurrentMember: false,
    items: [],
    itemsOnDisplay: [],
    mainText: null,
    pagination: null,
    queryParams: {},
    totalItems: 0,
    reduxContainer: {},
    searchLanguages: []
};
